/**
 * The Bill total a person typed, shaped for the push request — or `undefined` when the push should use
 * what OCR extracted. Only a SAVED edit counts: an edit still open is a draft, not a decision. A field
 * cleared to empty is "no override", never "pay nothing". An explicit zero is passed through so the
 * server refuses it with a reason the operator can read, rather than being silently swapped for the
 * extracted figure.
 */
export const getBillTotalOverride = _ref => {
  let value = _ref.value,
    isEdited = _ref.isEdited,
    isEditable = _ref.isEditable;
  if (!isEdited || isEditable) return undefined;
  const text = String(value !== null && value !== void 0 ? value : '').trim();
  if (text === '') return undefined;
  const parsed = Number(text.replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : undefined;
};